import { restClient } from '@/api/client'
import { endpoints } from '@/api/endpoints'

const q = (p: Record<string, unknown>) => new URLSearchParams(
  Object.entries(p).filter(([, v]) => v !== undefined && v !== null && v !== '').reduce((a, [k, v]) => ({ ...a, [k]: String(v) }), {})
).toString()

export const collectorService = {
  // Collector's own views
  cashInHand: (p: { page?: number; limit?: number } = {}) =>
    restClient.get(`${endpoints.collector.getCashInHand}?${q({ page: p.page??1, limit: p.limit??15 })}`).then(r => r.data),
  collectCash: (d: Record<string, unknown>) =>
    restClient.post(endpoints.collector.collectCash, d).then(r => r.data),
  collectedListPerTransaction: (p: { page?: number; limit?: number } = {}) =>
    restClient.get(`${endpoints.collector.collectedListPerTransaction}?${q({ page: p.page??1, limit: p.limit??15 })}`).then(r => r.data),
  // Admin's view of collector
  adminCashInHand: (p: { page?: number; limit?: number } = {}) =>
    restClient.get(`${endpoints.collectorAdminView.cashInHand}?${q({ page: p.page??1, limit: p.limit??15 })}`).then(r => r.data),
  adminCollectedCash: (p: { page?: number; limit?: number } = {}) =>
    restClient.get(`${endpoints.collectorAdminView.collectedCash}?${q({ page: p.page??1, limit: p.limit??15 })}`).then(r => r.data),
}
